import React from 'react';
import styled from 'styled-components';

import messages from './messages';

import { FormattedDate, FormattedMessage } from 'react-intl';
import BlockAllocationsTable from './BlockAllocationsTable';

/*
OTA Codes:
1	Cancelled
2	Definite
3	Hold
4	Lost
5	Prospect
6	Strong tentative
7	Tentative
8	Weak tentative
*/
const convertStatus = (status) => {
    switch (status) {
        case 1:
            return 'Cancelled';
        case 2:
            return 'Definite';
        case 3:
            return 'Hold';
        case 4:
            return 'Lost';
        case 5:
            return 'Prospect';
        case 6:
            return 'Strong tentative';
        case 7:
            return 'Tentative';
        case 8:
            return 'Weak tentative';
        default:
            return 'Non-Guaranteed';
    }
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const BlockDetailsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;

    margin-bottom: 15px;
`;

const BlockDetailItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    & > div:first-child {
        font-weight: bold;
    }
`;

const BlockItemBody = ({ code, createdDateTime, lastModifiedDateTime, allocations, currency, status }) => (
    <Container>
        <div>
            <BlockDetailsContainer>
                <BlockDetailItem>
                    <FormattedMessage tagName="div" {...messages.codeLabel} />
                    <div>{code}</div>
                </BlockDetailItem>
                <BlockDetailItem>
                    <FormattedMessage tagName="div" {...messages.statusLabel} />
                    <div>{convertStatus(status)}</div>
                </BlockDetailItem>
                {createdDateTime !== null && (
                    <BlockDetailItem>
                        <FormattedMessage tagName="div" {...messages.createdDateTimeLabel} />
                        <div>
                            <FormattedDate value={createdDateTime} day="2-digit" month="short" year="numeric" />
                        </div>
                    </BlockDetailItem>
                )}
                <BlockDetailItem>
                    <FormattedMessage tagName="div" {...messages.lastModifiedDateTimeLabel} />
                    <div>
                        <FormattedDate
                            value={lastModifiedDateTime}
                            day="2-digit"
                            month="short"
                            year="numeric"
                            hour="2-digit"
                            minute="2-digit"
                            second="2-digit"
                        />
                    </div>
                </BlockDetailItem>
            </BlockDetailsContainer>
        </div>
        <div>
            <BlockAllocationsTable allocations={allocations} currency={currency} />
        </div>
    </Container>
);

export default BlockItemBody;
